<svg
  viewBox="0 0 215 232"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="125.566"
    y="9.81537"
    width="26.7692"
    height="133.846"
    transform="rotate(44.2779 125.566 9.81537)"
    fill="url(#paint0_linear_141_2)"
  />
  <g filter="url(#filter0_d_141_2)">
    <rect
      x="171.212"
      y="30.538"
      width="8.42427"
      height="40.1538"
      fill="url(#paint1_linear_141_2)"
    />
  </g>
  <g filter="url(#filter1_d_141_2)">
    <circle
      cx="175.424"
      cy="101.485"
      r="27.3789"
      stroke="url(#paint2_linear_141_2)"
      stroke-width="8.42427"
      shape-rendering="crispEdges"
    />
  </g>
  <rect width="214.154" height="31.2308" fill="url(#paint3_linear_141_2)" />
  <rect
    x="19.6308"
    y="0.892303"
    width="41.9385"
    height="231.108"
    fill="url(#paint4_linear_141_2)"
  />
  <defs>
    <filter
      id="filter0_d_141_2"
      x="167.643"
      y="27.8611"
      width="15.5627"
      height="47.2923"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology
        radius="0.892308"
        operator="dilate"
        in="SourceAlpha"
        result="effect1_dropShadow_141_2"
      />
      <feOffset dy="0.892308" />
      <feGaussianBlur stdDeviation="1.33846" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.521569 0 0 0 0 0.133333 0 0 0 0.7 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_141_2"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_141_2"
        result="shape"
      />
    </filter>
    <filter
      id="filter1_d_141_2"
      x="140.264"
      y="67.2169"
      width="70.3205"
      height="70.3205"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feMorphology
        radius="0.892308"
        operator="dilate"
        in="SourceAlpha"
        result="effect1_dropShadow_141_2"
      />
      <feOffset dy="0.892308" />
      <feGaussianBlur stdDeviation="1.33846" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.521569 0 0 0 0 0.133333 0 0 0 0.7 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_141_2"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_141_2"
        result="shape"
      />
    </filter>
    <linearGradient
      id="paint0_linear_141_2"
      x1="151.18"
      y1="144.367"
      x2="155.046"
      y2="12.8504"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.255208" stop-color="#8F732B" />
      <stop offset="0.83939" stop-color="#AC8522" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_141_2"
      x1="175.424"
      y1="30.538"
      x2="175.424"
      y2="70.6919"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.427083" stop-color="#C59318" />
      <stop offset="0.9897" stop-color="#E8C05E" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_141_2"
      x1="207.015"
      y1="58.4462"
      x2="208.068"
      y2="133.076"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#EFC867" />
      <stop offset="1" stop-color="#AD882B" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_141_2"
      x1="0"
      y1="31.2308"
      x2="217.723"
      y2="31.2308"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.255208" stop-color="#8F732B" />
      <stop offset="1" stop-color="#AC8522" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_141_2"
      x1="19.6308"
      y1="232"
      x2="19.6311"
      y2="0.892303"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.255208" stop-color="#8F732B" />
      <stop offset="1" stop-color="#AC8522" />
    </linearGradient>
  </defs>
</svg>

<style>
  svg {
    margin: auto;
    width: 100%;
    max-width: 12rem;
    position: relative;
  }
</style>